export const defaultProps = {
    timestamp: 0
};
